/**
 * Every number the rules use (docs/spec/02), in one place. Probabilities are "one in n" or
 * "k out of 128" as the original expressed them.
 */
export const RULES = {
  /** Digby moves a boulder one scan in this many while pushing against it. */
  pushOneIn: 4,
  /** Amoeba growth chance per cell per scan, out of 128: slow, then fast after `amoebaTime`. */
  amoebaSlow: 4,
  amoebaFast: 32,
  /** An amoeba this many cells big turns to boulders. */
  amoebaMax: 200,
  /** An object resting on slime drops through it one scan in this many (Deep). */
  slimeOneIn: 8,
  /** Seconds a clock adds (Deep). */
  clockBonus: 10,
  /** Cave time before the inbox hatches. */
  hatchMs: 2400,
  /** The clock pings through its last this many seconds. */
  warnSeconds: 10,
} as const;

/** Default tick length per level 1-5, milliseconds per scan. */
export const DEFAULT_TICKS: readonly number[] = [160, 150, 140, 130, 120];

/** Session numbers (docs/spec/02 §9). */
export const SESSION = {
  startLives: 3,
  maxLives: 9,
  bonusLifeEvery: 500,
  /** After Digby dies, the session moves on after this long, or on fire. */
  deathWaitMs: 2500,
} as const;
